import React from 'react'

const SideBarSkeleton = () => {
  return (
    <div>
        <div className="h-[138px] px-4 py-3 mb-6 bg-gray-300 rounded-lg">
            <div className="bg-gray-200 w-full h-full rounded-lg animate-pulse">

            </div>
        </div>
        <div className="h-[558px] px-4 py-4 mb-6 bg-gray-300 rounded-lg">
            <div className="mb-2 bg-gray-200 w-full h-[34px] rounded-lg animate-pulse">

            </div>
            <div className="mb-2 bg-gray-200 w-full h-[88px] rounded-lg animate-pulse">

            </div>
            <div className="mb-2 bg-gray-200 w-full h-[88px] rounded-lg animate-pulse">

            </div>
            <div className="mb-2 bg-gray-200 w-full h-[88px] rounded-lg animate-pulse">

            </div>
            <div className="mb-2 bg-gray-200 w-full h-[88px] rounded-lg animate-pulse">

            </div>
            <div className="mb-2 bg-gray-200 w-full h-[88px] rounded-lg animate-pulse">

            </div>
        </div>
        <div className="h-[558px] px-4 py-4 bg-gray-300 rounded-lg">
            <div className="mb-2 bg-gray-200 w-full h-[34px] rounded-lg animate-pulse">

            </div>
            <div className="mb-2 bg-gray-200 w-full h-[88px] rounded-lg animate-pulse">

            </div>
            <div className="mb-2 bg-gray-200 w-full h-[88px] rounded-lg animate-pulse">

            </div>
            <div className="mb-2 bg-gray-200 w-full h-[88px] rounded-lg animate-pulse">

            </div>
            <div className="mb-2 bg-gray-200 w-full h-[88px] rounded-lg animate-pulse">

            </div>
            <div className="mb-2 bg-gray-200 w-full h-[88px] rounded-lg animate-pulse">

            </div>
        </div>
        <div></div>
    </div>
  )
}

export default SideBarSkeleton